import { API } from '@Providers';

// TODO - AF-545 Missing interface
export default async function (data: any) {
  const endpoint = '/api/shelter/cart/add-outcome-to-cart';

  return API({ endpoint, method: 'post', payload: data });
}
